import { PositionByDepartmentSelectOptionType } from 'components/PositionByDepartmentSelectInput';

export function collectPositionOptionIds(
  options: Record<string, PositionByDepartmentSelectOptionType[]>,
): string[] {
  return Object.values(options)
    .flat()
    .map((option) => String(option.value));
}

export function getFirstPositionOptionId(
  options: Record<string, PositionByDepartmentSelectOptionType[]>,
): Nullable<string> {
  const firstOption = Object.values(options)[0]?.[0];
  return firstOption ? String(firstOption.value) : null;
}

export function getDefaultedPositionSelection(params: {
  positions: string[];
  options: Record<string, PositionByDepartmentSelectOptionType[]>;
  hasNextPage: boolean;
  searchTerm: string;
}): Nullable<string> {
  const { positions, options, hasNextPage, searchTerm } = params;
  if (searchTerm) return null;
  const firstOptionId = getFirstPositionOptionId(options);
  if (!firstOptionId) return null;
  if (positions.length !== 1) return firstOptionId;
  if (hasNextPage) return null;
  const loadedValues = collectPositionOptionIds(options);
  return loadedValues.includes(positions[0]) ? null : firstOptionId;
}
